/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingInfo_user = {
    readonly serviceId: string | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedPromoCode_user">;
    readonly " $refType": "PdpSharedShippingInfo_user";
};
export type PdpSharedShippingInfo_user$data = PdpSharedShippingInfo_user;
export type PdpSharedShippingInfo_user$key = {
    readonly " $data"?: PdpSharedShippingInfo_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfo_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingInfo_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '51591383856c8c358c49c964288cdc6c';
export default node;
